import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { gdprAPI } from '../../services/api';

const ConsentBanner: React.FC = () => {
  const { user, isAuthenticated, markConsentAccepted } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [saving, setSaving] = useState(false);

  // Only show for authenticated users who have NOT accepted consent
  if (!isAuthenticated || !user || user.consent_accepted_at || dismissed) {
    return null;
  }

  const handleAccept = async () => {
    setSaving(true);
    try {
      await gdprAPI.acceptConsent();
      markConsentAccepted();
      setDismissed(true);
    } catch (err) {
      console.error('Failed to accept consent:', err);
      // Still dismiss locally so user isn't stuck
      setDismissed(true);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 56,
      right: 0,
      zIndex: 1000,
      background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
      color: '#fff',
      padding: '10px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      fontSize: 13,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    }}>
      <span>
        By continuing to use Adroit you agree to our{' '}
        <Link to="/privacy" style={{ color: '#fff', textDecoration: 'underline', fontWeight: 600 }}>
          Privacy &amp; Data policy
        </Link>.
      </span>
      <button
        onClick={handleAccept}
        disabled={saving}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: '1px solid rgba(255,255,255,0.4)',
          color: '#fff',
          padding: '5px 16px',
          borderRadius: 6,
          cursor: 'pointer',
          fontWeight: 600,
          fontSize: 13,
          whiteSpace: 'nowrap',
          opacity: saving ? 0.6 : 1,
        }}
      >
        {saving ? 'Saving...' : 'I understand'}
      </button>
    </div>
  );
};

export default ConsentBanner;
